import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/logo-left.png'
import _imports_1 from '../assets/images/centerLogo.png'
import _imports_2 from '../assets/images/logo-right.png'


const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modalInner" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"modalHeader\"><div class=\"leftLogo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"centerLogo\"><img src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"rightLogo\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 1)
const _hoisted_4 = { class: "modalContent with-bg" }
const _hoisted_5 = { class: "modalContentInner" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "red" }, "Be responsible this Valentines! "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Myth "),
    /*#__PURE__*/_createTextVNode("– Security is the cloud provider’s responsibility.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Fact "),
    /*#__PURE__*/_createTextVNode(" – If you choose public cloud, the onus is on you to ensure your data, backup, protection and security are up to scratch.")
  ])
], -1)
const _hoisted_7 = { class: "modalFooterIn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-large btn-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
                }, "PLAY")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}